import React from 'react';
import { useTranslation } from 'react-i18next';
import worried from '../assets/worried.png';
export default function ErrorState() {
  const { t } = useTranslation();
  return (
    <div className="error-state">
      <h2>{t('common.error.occur')} :(</h2>
      <img src={worried} alt={t('common.error')} />
    </div>
  );
}
